export default __webpack_public_path__ + "static/media/star-regular.d9727f76.svg";